import React, { useContext } from "react"
import { graphql, useStaticQuery } from "gatsby";
import useLiveData from 'hooks/useLiveData';
import ComparisonCardsContentLink from 'components/ComparisonCardsContentLink';
import { PersonalizationContext } from 'components/Personalization/PersonalizationContext';

const ComparisonCardsContentLinkProvider = (props) => {
	const { matchAudience } = useContext(PersonalizationContext);
	const data = useStaticQuery(graphql`
		query allSmartTagsComparisonCardsContentLink {
			allSmartTagsComparisonCardsContentLink {
				edges {
					node {
						id
						background
						backgroundImage
						backgroundProps
						flush
						padding
						title
						cards {
							description
							image1
							image2
							link
							linkText
							title
						}
						Audience {
						  ...AudienceRelationshipDetailsFragment
						}
					}
				}
			}
		}
	`);
	const { response } = useLiveData({
		namespace: 'SmartTags',
		model: 'ComparisonCardsContentLink',
		method: 'all',
		graphqlKey: 'allSmartTagsComparisonCardsContentLink',
		apiParams: {
			archived: false,
			approved: true,
			deleted: false,
		},
		staticData: data,
	});

	if (response.data.length === 0)return null;
	let attr;
	for (let item of response.data) {
		if (item.id === props.id)attr = item;
	}
	if (!attr)return null;
	if (!matchAudience(attr.Audience))return null;

	return (
		<ComparisonCardsContentLink {...attr} matchAudience={matchAudience} />
	)
};

export default ComparisonCardsContentLinkProvider;